import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface CostDetails {
  materialCostPerKg: number;
  energyCostPerHour: number;
  preProcessingBaseRate: number;
  preProcessingPerModel: number;
  postProcessingBaseRate: number;
  postProcessingPerModel: number;
  wearAndTearPerHour: number;
}

interface ModelInfo {
  name: string;
  volumeCm3: number;
  quantity: number;
}

interface PriceBreakdownProps {
  materialCost: number;
  energyCost: number;
  preProcessingCost: number;
  postProcessingCost: number;
  wearAndTearCost: number;
  totalCost: number;
  models: ModelInfo[];
  costDetails: CostDetails;
}

const PriceBreakdown = ({
  materialCost,
  energyCost,
  preProcessingCost,
  postProcessingCost,
  wearAndTearCost,
  totalCost,
  models,
  costDetails,
}: PriceBreakdownProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Kostenaufschlüsselung</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {models.map((model, index) => (
          <div key={index} className="space-y-2">
            <div className="flex justify-between font-medium">
              <span>{model.name}</span>
              <span>{model.volumeCm3.toFixed(2)} cm³ × {model.quantity}</span>
            </div>
          </div>
        ))}
        <div className="h-px bg-border" />
        <div className="flex justify-between">
          <span>Materialkosten ({costDetails.materialCostPerKg.toFixed(2)} €/kg):</span>
          <span className="font-medium">{materialCost.toFixed(2)} €</span>
        </div>
        <div className="flex justify-between">
          <span>Energiekosten:</span>
          <span className="font-medium">{energyCost.toFixed(2)} €</span>
        </div>
        <div className="flex justify-between">
          <span>Vorbereitungskosten (Basis {costDetails.preProcessingBaseRate} € + {costDetails.preProcessingPerModel} € pro zusätzliches Modell):</span>
          <span className="font-medium">{preProcessingCost.toFixed(2)} €</span>
        </div>
        <div className="flex justify-between">
          <span>Nachbereitungskosten (Basis {costDetails.postProcessingBaseRate} € + {costDetails.postProcessingPerModel} € pro zusätzliches Modell):</span>
          <span className="font-medium">{postProcessingCost.toFixed(2)} €</span>
        </div>
        <div className="flex justify-between">
          <span>Verschleißkosten:</span>
          <span className="font-medium">{wearAndTearCost.toFixed(2)} €</span>
        </div>
        <div className="h-px bg-border" />
        <div className="flex justify-between text-lg font-semibold">
          <span>Gesamtkosten:</span>
          <span className="text-primary">{totalCost.toFixed(2)} €</span>
        </div>
      </CardContent>
    </Card>
  );
};

export default PriceBreakdown;